<!--
 * 页面统一布局
-->
<template>
  <div class="page-layout">
    <div v-if="hasSidebar" class="page-layout__sidebar" :style="sidebarStyle">
      <div
        v-show="!shrink"
        class="page-layout__sidebar__content"
      >
        <!-- 侧栏插槽 -->
        <slot name="sidebar" />
      </div>

      <!-- 收起按钮 -->
      <div
        v-if="!shrink"
        @click="shrink = true"
        class="page-layout__sidebar-shrink"
      >
        <img
          :src="require('@/assets/images/shrink.png')"
          style="width: 20px;"
        />
      </div>
    </div>

    <div class="page-layout__content" :style="contentStyle">
      <!-- 展开按钮 -->
      <div
        v-if="hasSidebar && shrink"
        class="page-layout__sidebar-shrink-open"
        @click.stop="shrink = false"
      >
        <img
          :src="require('@/assets/images/shrink.png')"
          style="width: 20px;transform: rotateY(180deg);"
        />
      </div>

      <!-- 顶部 -->
      <div class="page-layout__header">
        <div>
          <slot name="headerLeft"></slot>
        </div>
        <a-space>
          <slot name="headerRight"></slot>
        </a-space>
      </div>

      <!-- 默认插槽 -->
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "PageLayout",
  props: {
    /**
     * 侧栏宽度
     */
    sidebarWidth: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      shrink: false, // 是否收起侧栏
    };
  },
  computed: {
    hasSidebar() {
      return !!this.$slots.sidebar;
    },
    sidebarStyle() {
      return {
        width: this.shrink ? "0px" : `${this.sidebarWidth}px`,
      };
    },
    contentStyle() {
      return {
        paddingLeft: this.hasSidebar ? "10px" : "0",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.page-layout {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;

  &__sidebar {
    transition: all ease 0.3s;
    height: 100%;
    position: relative;

    &::after {
      content: "";
      display: block;
      width: 1px;
      height: 100%;
      background: #e8e8e8;
      position: absolute;
      right: 0;
      top: 0;
    }

    &__content {
      height: 100%;
      overflow: auto;
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  &__content {
    height: 100%;
    flex: 1;
    overflow: auto;
    position: relative;
  }

  &__sidebar-shrink {
    background: rgba(0, 179, 139, 0.2);
    z-index: 10;
    width: 25px;
    height: 60px;
    position: absolute;
    top: 300px;
    right: 0px;
    cursor: pointer;
    border-radius: 8px 0px 0px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__sidebar-shrink-open {
    background: rgba(0, 179, 139, 0.2);
    z-index: 10;
    width: 25px;
    height: 60px;
    left: 0px;
    position: absolute;
    top: 300px;
    cursor: pointer;
    border-radius: 0px 8px 8px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
